import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  MAX_PAGE_HEIGHT,
  MAX_PAGE_WIDTH,
  WEB_CONTENT_WIDTH,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addExerciseWrapper: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 1),
    },
  },
  titleTextField: {
    '& .MuiOutlinedInput-root': {
      height: '48px',
    },
  },
  addExerciseHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  addExerciseForm: {
    width: '100%',
  },

  exerciseOptionItem: {
    padding: '4px 8px',
    minWidth: 200,
  },

  addExerciseCategoryItem: {
    maxWidth: 'unset',
  },

  formItem: {
    marginTop: '8px !important',
  },

  optionsLabel: {
    ...theme.mixins.appLabel,

    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
    '& svg': {
      marginRight: 8,
    },
  },

  optionsContainer: {
    display: 'flex',
    gap: 4,
    flexWrap: 'wrap',
  },

  addOptionButton: {
    borderRadius: 2,
    textTransform: 'capitalize',
    backgroundColor: 'transparent',
    lineHeight: 18,
    height: 26,
    padding: '4px 8px',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },

  optionItem: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    width: 'calc(50% - 4px)',
    maxWidth: 'calc(50% - 4px)',
    minWidth: 'calc(50% - 4px)',
    padding: theme.spacing(1.5),

    '& .MuiFormControlLabel-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100% !important',
    },

    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: '100%',
    },
  },

  deleteTag: {
    width: 20,
    height: 20,
    minWidth: 0,
    padding: 0,
    marginLeft: 8,
    backgroundColor: theme.palette.grey[200],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    '&:hover svg path': {
      fill: theme.palette.primary.main,
    },

    '& svg path': {
      fill: theme.palette.grey[600],
    },
  },

  buttonWrapper: {
    padding: '16px 0',
  },
  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
      maxHeight: '48px',
    },
  },
  formulaFieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  formulaSelect: {
    flex: 1,
    minWidth: 0,
  },
  formulaWrapper: {
    '& .MuiFormControl-root': {
      minHeight: '48px',
      maxHeight: '48px',
      marginTop: 0,
    },
  },

  newExerciseDialog: {
    width: WEB_CONTENT_WIDTH,
    maxWidth: MAX_PAGE_WIDTH,

    [theme.breakpoints.down('md')]: {
      width: MAX_PAGE_WIDTH,
      margin: 0,
      height: MAX_PAGE_HEIGHT,
    },
  },

  optionsGrid: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    width: '100%',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
